import { Entity } from '@sqior/js/entity';

export type ORWorkflowIncidentData = { procedure: Entity; incident: string; selected: boolean };

/** Path for operations reporting OR workflow incident */
export const ORWorkflowIncidentPath = 'orworkflow-incident';
